// extracted by mini-css-extract-plugin
export var body = "testimonial-module--body--KqyLV";
export var btn = "testimonial-module--btn--Snb1n";
export var buttonsContainer = "testimonial-module--buttonsContainer--Gv8nM";
export var sbShowMain = "testimonial-module--sb-show-main--Ila00";
export var testimonial = "testimonial-module--testimonial--tV7mw";
export var testimonialListingContainer = "testimonial-module--testimonialListingContainer--Q6O+E";